<template>
  <div class="ui-block">
    <div class="w-calendar calendar-container">
      <div class="calendar">
        <table v-if="days && days.length">
          <thead>
            <tr><td>Mon</td><td>Tue</td><td>Wed</td><td>Thu</td><td>Fri</td><td>Sat</td><td>Sun</td></tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-for="item in days.slice(0,7)"
                :key="item.id"
                data-month=""
                data-day=""
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay || item.month == currentMonth">
                  <a
                    class="text"
                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>
                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="item in days.slice(7,14)"
                :key="item.id"
                data-month=""
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay || item.month == currentMonth">
                  <a
                    class="text"

                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>
                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="item in days.slice(14,21)"
                :key="item.id"
                data-month=""
                data-day=""
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay || item.month == currentMonth">
                  <a
                    class="text"
                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>
                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="item in days.slice(21,28)"
                :key="item.id"
                data-month="12"
                data-day="item.day"
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay || item.month == currentMonth">
                  <a
                    class="text"

                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>

                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
            <tr v-if="days.length > 28">
              <td
                v-for="item in days.slice(28,35)"
                :key="item.id"
                data-month="12"
                data-day="item.day"
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay || item.month == currentMonth">
                  <a
                    class="text"

                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>
                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
            <tr v-if="days.length > 35">
              <td
                v-for="item in days.slice(35,42)"
                :key="item.id"
                data-month="12"
                data-day="item.day"
                :class="item.classes"
              >
                <span v-if="item.isSelectedDay">
                  <a
                    class="text"

                    @click="getAnswersByDay(item.date)"
                  >{{ item.day }}</a>
                </span>
                <span v-else>
                  {{ item.day }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ... end W-Calendar -->
  </div>
</template>

<script>
  import { format } from 'date-fns'
  import {mapState} from "vuex";
  import {EventBus} from "../../../event-bus";
  import calendarStore from '../../../store/modules/personal/calendar'

  export default {
    name: 'CalendarContainerAnswer',
    props: {
      date: {
        type: Date,
        default: function () { return {} }
      },
      from: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        dateContext: new Date(this.date),
        currentMonth: format(new Date(this.date),'MM'),
        currentYear: format(new Date(this.date),'yyyy')
      }
    },
    computed: mapState({
      days: state => state.calendar ? state.calendar.answerCalendar : []
    }),
    created () {
      if (!this.$store.hasModule('calendar')) {
        this.$store.registerModule('calendar', calendarStore)
      }
      this.$store.dispatch('calendar/answerMonthTable', this.dateContext)
      EventBus.$emit('changed-month-day', this.dateContext)
    },
    beforeDestroy () {
      this.$store.unregisterModule('calendar')
    },
    methods: {
      getAnswersByDay (date) {
        this.selectedDay =format(new Date(date), 'dd')
        this.dateContext = date

        EventBus.$emit('changed-month-day', this.dateContext)
      }
    }
  }
</script>

<style scoped>
  .fc-other-month {
    color: lightgray;
  }
</style>
